import React from 'react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// import { AuthContext } from '../Contexts/AuthContext/AuthProvider';

function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue.pop() : '';
}

const LoginRoute = ({ children }) => {

    // const { authId, token } = useContext(AuthContext);
    const location = useLocation();
    const [token, setToken] = useState(getCookie('WLF_Mobile_admin_token'));
    // const [data, setData] = useState([]);
    // const [loading, setLoading] = useState(true);

    // useEffect(() => {

    //     const fetchUser = async () => {
    //         try {
    //             const res = await fetch(
    //                 `https://api.wlfmobile.com/api/admin/auth/view/${authId?._id}?deviceId=${authId?.deviceId}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                 }
    //             );

    //             const data = await res.json();
    //             if (data) {
    //                 setData(data.success);
    //                 setLoading(false);
    //             }

    //         } catch (err) {
    //             // console.log(err)
    //         }
    //     };

    //     fetchUser();
    // }, [authId])


    // if (loading) {
    //     return <></>;
    // }

    if (!token) {
        return children;

    }
    else if (token) {
        return <Navigate to='/admin/dashboard' state={{ from: location }} replace ></Navigate>

    }

}

export default LoginRoute;